import React, { ReactElement } from "react";
import styles from "./userReviewCta.module.scss";
import classNames from "classnames";
import { Colors } from "../../theme";
import { Star01 } from "@untitled-ui/icons-react";
import { Text } from "@kunduz/ui-atoms";
import Link from "next/link";

export const UserReviewCta = (props: Props): ReactElement => {
  function isStarFilled(index: number) {
    if (!props.rating) return false;
    return index - 0.5 <= parseFloat(props.rating.replace(",", "."));
  }

  return (
    <section
      className={classNames(styles.base, [styles[`theme-${props.theme}`]])}
    >
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <p className={styles.title}>{props.title}</p>
          <div className={styles.meta}>
            {props.rating !== undefined && (
              <div className={styles.ratingWrapper}>
                <div className={styles.starWrapper}>
                  {Array.from(Array(5)).map((s, t) => (
                    <Star01
                      key={`star_${t}`}
                      color="#FEC84B"
                      width={20}
                      height={20}
                      className={classNames({
                        [styles.filled]: isStarFilled(t + 1),
                      })}
                    />
                  ))}
                </div>
              </div>
            )}

            <div className={styles.metaRight}>
              {props.ratingText && (
                <p className={styles.ratingText}>{props.ratingText}</p>
              )}

              <Text variant="textxl">•</Text>

              {props.reviewText && (
                <Link
                  href={props.reviewUrl}
                  target={props.reviewUrlTarget}
                  className={styles.reviewText}
                  onClick={props.onClick}
                >
                  {props.reviewText}
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

interface Props {
  theme: Colors;
  title: string;
  rating?: string;
  ratingText?: string;
  reviewText?: string;
  reviewUrl: string;
  reviewUrlTarget: string;
  onClick?: () => void;
}
